import { FunctionComponent, PropsWithChildren } from 'react';
import {
  PageBodyContentContainer,
  PageMainBodyContentContainer,
} from '../../../app-kit/components/PageContentContainer/PageContentContainer';
import { SchoolFactsBrickWithData } from './subcomponents/SchoolFactsBrick/SchoolFactsBrickWithData';
import { SchoolCatchmentMapBrickWithData } from './subcomponents/SchoolCatchmentMapBrick/SchoolCatchmentMapBrickWithData';
import { NearbySchoolsBrickWithData } from './subcomponents/NearbySchoolsBrick/NearbySchoolsBrickWithData';
import { SchoolCatchmentDisclaimerBrickWithData } from './subcomponents/SchoolCatchmentDisclaimerBrick/SchoolCatchmentDisclaimerBrickWithData';
import { NearbySoldPropertiesBrickWithData } from './subcomponents/NearbySoldPropertiesBrick/NearbySoldPropertiesBrickWithData';
import { ScreenReaderTitle } from '../../../app-kit/helpers/screenReaderOnly';
import { useSchoolPageBySlugTabContentQuery } from '../../graphql/useSchoolPageBySlugTabContentQuery';

export const SchoolPageTabContentOverview: FunctionComponent<PropsWithChildren> = () => {
  const { data } = useSchoolPageBySlugTabContentQuery();
  const tabContent = data?.schoolPageBySlug?.tabContent;
  if (!tabContent) return null;

  const { title } = tabContent;
  return (
    <PageBodyContentContainer>
      {title && <ScreenReaderTitle>{title}</ScreenReaderTitle>}
      <PageMainBodyContentContainer>
        <SchoolFactsBrickWithData />
        <SchoolCatchmentMapBrickWithData />
        <SchoolCatchmentDisclaimerBrickWithData />
        <NearbySoldPropertiesBrickWithData />
        <NearbySchoolsBrickWithData />
      </PageMainBodyContentContainer>
    </PageBodyContentContainer>
  );
};
